import { __exports as e } from "../../../../_virtual/is-valid-input-type.js";
Object.defineProperty(e, "__esModule", { value: !0 });
e.isValidInputType = void 0;
function i(t) {
  return typeof t == "string" || t instanceof String;
}
e.isValidInputType = i;
export {
  e as default
};
